import apiClient from './client';

export interface PrepareEnrichSubmission {
  id: number;
  name: string;
  email: string;
  phone: string;
  prepareEnrichRequested: boolean;
  prepareEnrichRequestedAt: string;
  prepareEnrichStatus: 'not_started' | 'started' | 'scheduled' | 'complete';
  prepareEnrichStatusUpdatedAt: string | null;
  prepareEnrichNotes: string | null;
  prepareEnrichData: {
    candidateName: string;
    candidateEmail: string;
    candidatePhone: string;
    wifeName: string;
    wifeEmail: string;
    wifePhone: string;
  };
  createdAt: string;
  user?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
  };
}

export interface PrepareEnrichStats {
  not_started: number;
  started: number;
  scheduled: number;
  complete: number;
  total: number;
}

export interface PrepareEnrichListResponse {
  data: PrepareEnrichSubmission[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    pages: number;
  };
}

export const getPrepareEnrichSubmissions = async (params?: {
  status?: string;
  page?: number;
  limit?: number;
}): Promise<PrepareEnrichListResponse> => {
  const response = await apiClient.get('/prepare-enrich/submissions', { params });
  return response.data;
};

export const getPrepareEnrichSubmission = async (id: number): Promise<{ data: PrepareEnrichSubmission }> => {
  const response = await apiClient.get(`/prepare-enrich/submissions/${id}`);
  return response.data;
};

export const updatePrepareEnrichStatus = async (
  id: number,
  data: { status: string; notes?: string }
): Promise<{ message: string; data: any }> => {
  const response = await apiClient.patch(`/prepare-enrich/submissions/${id}/status`, data);
  return response.data;
};

export const getPrepareEnrichStats = async (): Promise<{ data: PrepareEnrichStats }> => {
  const response = await apiClient.get('/prepare-enrich/stats');
  return response.data;
};

